(function () {
  'use strict';

  angular
    .module('expurgo')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.expurgo', {
        url: '/expurgo',
        views: {
          'content@': {
            templateUrl: 'expurgo/expurgo.tpl.html',
            controller: 'ExpurgoCtrl',
            controllerAs: 'expurgoCtrl'
          }
        },
        data: {
          titulo: 'core-permissoes.purge.dismissalInvalidities'
        }
      });
  }
}());
